<template>
  <b-modal :id="modalId" :title="selectedPool | poolName | groupName(selectedPool)" hide-footer no-close-on-backdrop>
    <b-tabs content-class="mt-3" v-if="selectedPool">
      <b-tab title="Profile" active>
        <div class="tab-box">
          <profile-row heading="TYPE" :info="selectedPool.license_type.name" />
          <profile-row heading="AVAILABLE" :info="selectedPool.count" />
          <profile-row heading="CHECK-IN INTERVAL" v-if="selectedOrganization" :info="selectedOrganization.refresh_interval" />
          <profile-row heading="ORGANIZATION" v-if="selectedOrganization" :info="selectedOrganization.name" />
          <profile-row heading="GROUP" v-if="selectedPool.group" :info="selectedPool.group.name" />
          <profile-row heading="EXPIRES" :info="selectedPool.contract_end | prettyDate" />
        </div>
      </b-tab>
      <b-tab title="Transfer">
        <transfer-form :pool="selectedPool" @hasUpdate="hasUpdate" />
      </b-tab>
      <b-tab title="Transactions">
        <transaction-table :poolId="selectedPool.id" :perPage="5" />
        <div class="tab-box">
          <router-link :to="`/transactions/${selectedPool.id}`" class="btn btn-info">History</router-link>
        </div>
      </b-tab>
      <b-tab title="Credit Licenses" v-if="canCreditLicenses">
        <credit-licenses-form :pool="selectedPool" @hasUpdate="hasUpdate" />
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import TransferForm from '../Forms/TransferForm.vue';
import CreditLicensesForm from '../Forms/CreditLicensesForm.vue';
import TransactionTable from '../Tables/TransactionTable.vue';
import ProfileRow from '../ProfileRow.vue';
import config from '../../config';
import { mapGetters } from 'vuex';

export default {
  name: 'LicenseModal',
  components: {
    TransferForm,
    CreditLicensesForm,
    TransactionTable,
    ProfileRow
  },
  methods: {
    hasUpdate() {
      this.$emit('hasUpdate');
    }
  },
  filters: {
    groupName(poolName, pool) {
      if (pool && pool.group) {
        return `${poolName} - ${pool.group.name}`
      }
      return poolName;
    }
  },
  computed: {
    ...mapGetters('licensePool', ['selectedPool']),
    ...mapGetters('organization', ['selectedOrganization']),
    ...mapGetters('group', ['topLevelGroup']),
    ...mapGetters('user', ['isStaffUser', 'isSuperUser']),
    modalId() {
      return config.LICENSE_MODAL_ID;
    },
    canCreditLicenses() {
      return (this.isSuperUser || this.isStaffUser) &&
        this.selectedPool.group_id == this.topLevelGroup.id;
    }
  }
};
</script>
